import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {callOpenWorkOrderForSale} from '../../../utilities/openWorkOrder';
import {formatDeliveryTimeSlots} from '../../../utilities/dateUtils';
import {ePages} from './Constants';

export const getProductsAndServices = createAsyncThunk('standAlonePurchaseSaleBlock/getProductsAndServices', async (thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('getProductsAndServices', []);
    return {
      productsAndServices: result.Body,
      returnCode: result.Header.ReturnCode.toString(),
    };
  } catch (error) {
    console.log('@@@ Exception => ' + error);
    return {
      productAndServices: {},
      returnCode: '99',
    };
  }
});

export const getTechnicianSlotsDeliveries = createAsyncThunk(
  'standAlonePurchaseSaleBlock/getDeliveryNoProducts',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getDeliverySlotsNoProd', [
        data.city,
        data.street,
        data.homeNum,
        data.slotTimeNoteOrder,
        data.slotTimeDate,
        data.slotTimeFrom,
      ]);
      return result;
    } catch (error) {
      return error;
    }
  }
);

export const createStandAloneSale = createAsyncThunk('standAlonePurchaseSaleBlock/createStandAloneSale', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('createStandAloneSale', data);
    return result;
  } catch (error) {
    return error;
  }
});

const initialState = {
  epiContent: '',
  form: {
    cityCode: '',
    cityName: '',
    streetCode: '',
    streetName: '',
    home: '',
    floor: '',
    apartment: '',
    zipCode: '',
    phone: '',
    email: '',
    entry: '',
    valid: '',
  },
  tvProducts: [],
  personalInfo: {
    firstName: '',
    lastName: '',
    id: '',
  },
  error: {
    id: '',
  },
  productQuantity: 1,
  percent: '0',
  progressBarPoints: [],
  selectedDeliverySlot: '',
  page: ePages.SUBSCRIPTIONS_INFO_PAGE, // TODO: change to default
  deliveryTimeSlots: [],
  isLoading: false,
  initCompleted: false,
  flowType: 'existsCustomer',
};

const standAlonePurchaseSaleSlice = createSlice({
  name: 'standAlonePurchaseSaleBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    setIsSubmit: (state, action) => {
      state.form.isSubmit = action.payload;
    },
    setSelectedDeliverySlot: (state, action) => {
      state.selectedDeliverySlot = action.payload;
    },
    setAddressValues: (state, action) => {
      state.form.cityCode = action.payload.cityCode;
      state.form.cityName = action.payload.cityName;
      state.form.streetCode = action.payload.streetCode;
      state.form.streetName = action.payload.streetName;
      state.form.apartment = action.payload.apartment;
      state.form.home = action.payload.home;
      state.form.floor = action.payload.floor;
      state.form.email = action.payload.email;
      state.form.phone = action.payload.phone;
      state.form.valid = true;
      state.tvProducts.forEach((prd) => {
        if (prd.chosenSubscription) {
          prd.fullAddress = `${action.payload.streetName} ${action.payload.home}, ${action.payload.cityName}`;
        }
      });
    },
    setChosenSubscription: (state, action) => {
      state.tvProducts = state.tvProducts.map((prd) => {
        if (prd.ban === action.payload) {
          state.form.email = prd.userName;
          prd.chosenSubscription = true;
        }
        return prd;
      });
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setProductQuantity: (state, action) => {
      state.productQuantity = action.payload;
    },
    initStandAlonePurchaseSale: {
      reducer: (state, action) => {
        state.initCompleted = true;
        state.epiContent = action.payload;
      },
      prepare: (action) => {
        const {iContent} = action;
        const payload = {
          iContent,
        };

        return {payload};
      },
    },
    setError: (state, action) => {
      state.error.id = action.payload.id ?? '';
      state.page = ePages.ERROR_PAGE;
      state.error.isDisplay = action.payload.isDisplay;
    },
    goToPage: (state, action) => {
      state.page = action.payload.page;
      state.percent = action.payload.percent;
    },
    reportAnalytics: (action) => {},
    reportDWH: (action) => {},
  },
  extraReducers: {
    [getProductsAndServices.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.returnCode = action.payload.returnCode;
      state.page = ePages.SUBSCRIPTIONS_INFO_PAGE;

      try {
        const {saProducts, banPsidInfo, bundleList} = action.payload.productsAndServices;
        const tvBanList = banPsidInfo.filter((ban) => ban.hasTvProduct === true);
        const tvProducts = tvBanList.map((ban) => {
          let fullAddress = 'לא ידוע';
          const personalInfo = {
            id: ban.idNumber,
          };
          state.personalInfo = personalInfo;
          state.form.city = ban.billingAddress.cityCode ?? '';
          state.form.cityName = ban.billingAddress.city ?? '';
          state.form.street = ban.billingAddress.streetCode ?? '';
          state.form.streetName = ban.billingAddress.streetName ?? '';
          state.form.home = ban.billingAddress.houseNum ?? '';
          if (ban.billingAddress.city) {
            fullAddress = ban.billingAddress.streetName
              ? `${ban.billingAddress.streetName} ${ban.billingAddress.houseNum}, ${ban.billingAddress.city}`
              : ban.billingAddress.city;
          } else {
            fullAddress = 'כתובת לא מוזנת';
          }
          return {
            ban: ban?.ban ?? '',
            userName: '',
            paymentToken: ban?.paymentToken ?? '',
            fullAddress,
            hasFinancialIssue: ban.collectionInd !== null && ban.collectionInd?.toUpperCase() !== 'N',
            chosenSubscription: false,
          };
        });
        const tvSaProducts = saProducts.filter((prd) => prd.productType.toUpperCase() === 'TV');

        tvSaProducts.forEach((saPrd) => {
          // searching for stand alone tv products user name
          tvProducts.forEach((prd) => {
            if (prd.ban === saPrd.ban && prd.userName === '') {
              prd.userName = saPrd.userName;
              try {
                prd.equipment = [...saPrd.equipment];
              } catch (e) {
                // in case ban of cellcom TV has no equipment (smart TV)
                console.log(`@@@ product and services exception => ${e.message}`);
              }
            }
          });
        });

        bundleList.forEach((bdl) => {
          // searching for bundle tv products user name
          const bundleTvProducts = bdl.products.filter((prd) => prd.productType.toUpperCase() === 'TV');
          bundleTvProducts.forEach((bdlTvPrd) => {
            tvProducts.forEach((prd) => {
              if (prd.ban === bdlTvPrd.ban && prd.userName === '') {
                prd.userName = bdlTvPrd.userName;
                try {
                  prd.equipment = [...bdlTvPrd.equipment];
                } catch (e) {
                  // in case ban of cellcom TV has no equipment (smart TV)
                  console.log(`@@@ product and services exception => ${e.message}`);
                }
              }
            });
          });
        });

        state.form.email = tvProducts.filter((prd) => prd.userName !== '')[0]?.userName ?? '';
        state.tvProducts = tvProducts;
      } catch (e) {
        console.log(`@@@ get products and services Exception => ${e.message}`);
        state.page = ePages.ERROR_PAGE;
      }
    },
    [getTechnicianSlotsDeliveries.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = {errorId: 19, message: action.payload.message};
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = {errorId: 20, message: action.payload.message};
      }

      try {
        state.deliveryTimeSlots = formatDeliveryTimeSlots(action.payload.Body);
      } catch (error) {
        state.form.errorObj = {errorId: 20, message: action.payload.message};
      }
      if (state.form.deliveryTime) {
        state.form.deliveryTime = '';
        state.form.deliveryTimePlaceholder = 'בחר מועד';
      }
    },
  },
});

export const {
  resetBlock,
  goToPage,
  setIsLoading,
  initStandAlonePurchaseSale,
  setAddressValues,
  setChosenSubscription,
  setSelectedDeliverySlot,
  setProductQuantity,
  setError,
  reportDWH,
} = standAlonePurchaseSaleSlice.actions;

export default standAlonePurchaseSaleSlice.reducer;
